module.exports = __webpack_public_path__ + "img/tk_prosto.80c297f8.svg";